var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedStones.length > 0
    ? _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "container-fluid selected-stones" },
          [
            _vm._l(_vm.selectedStones, function(stone, index) {
              return _c("div", [
                index == 0
                  ? _c("div", { staticClass: "main-stone-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("build_your_jewel.selected_diamond"))
                      )
                    ])
                  : index == 1
                  ? _c("div", { staticClass: "other-stone-title mt-3" }, [
                      _vm._v(
                        _vm._s(_vm.$t("build_your_jewel.selected_pairs")) + " "
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "row stone-row" }, [
                  _c("div", { staticClass: "col-md-8" }, [
                    _vm._v(_vm._s(stone.cartItem.description))
                  ]),
                  _c("div", { staticClass: "col-md-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn edit-stone-btn",
                        on: {
                          click: function($event) {
                            return _vm.changeStone(stone, index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("build_your_jewel.edit_stone")))]
                    )
                  ])
                ])
              ])
            }),
            _vm.selectedStones.length != _vm.stonesNumber
              ? _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "row pairs-title" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm._v(_vm._s(_vm.$t("build_your_jewel.selectPairs")))
                    ])
                  ])
                ])
              : _vm._e()
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }